import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';

interface ValidationErrorPopupLocalProps {
    message: string;
    show: boolean;
    onClose: () => void;
    header?: string | null;
    showCancel?: boolean; // NEW: Show cancel button for actionable warnings
    onCancel?: () => void; // NEW: Optional cancel handler
    okButtonText?: string; // NEW: Customizable OK button text
    textClass? : string; // NEW: Customizable text class
    enableScroll?: boolean; // NEW: Enable scrolling for long content
}

type ValidationErrorPopupProps = ValidationErrorPopupLocalProps & ToxnotComponentProperties;

class ValidationErrorPopupComponent extends ToxnotComponent<ValidationErrorPopupProps> {

    render() {
        const { 
            message, 
            show, 
            onClose, 
            onCancel,
            showCancel = false, 
            okButtonText,
            textClass = "text-light",
            enableScroll = false
        } = this.props;
        
        if (!show) {
            return null;
        }

    return (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog" style={{ marginTop: '15%' }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">
                            <span className="glyphicon glyphicon-exclamation-sign text-warning" style={{ marginRight: '8px' }}></span>
                            {this.props.header || this.localizeString("Validation Error")}
                        </h4>
                        <button type="button" className="close" onClick={showCancel? onCancel : onClose}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body" style={enableScroll ? { maxHeight: '250px', overflowY: 'auto' } : {}}>
                        {message.split('\n').map((line, index) => (
                            <p key={index} className={textClass} style={{ marginBottom: '2px' }}>{this.localizeString(line)}</p>
                        ))}
                    </div>
                    <div className="modal-footer">
                        {showCancel && (
                            <button 
                                type="button" 
                                className="btn btn-default" 
                                onClick={onCancel}
                                style={{ marginRight: '10px' }}
                            >
                                {this.localizeString("Cancel")}
                            </button>
                        )}
                        <button type="button" className="btn btn-primary" onClick={onClose}>
                            {okButtonText || this.localizeString("OK")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
    }
}

export const ValidationErrorPopup = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ValidationErrorPopupComponent);
